import { COOKIE_AGE_VERIFIED } from '~/utils/constants'

export default async function ({ store, redirect, localePath, $cookies, $ageApi }) {
	const ageCookie = $cookies.get(COOKIE_AGE_VERIFIED)

	if (ageCookie?.underAge) {
		return redirect({
			path: localePath('/registration/profile/gate'),
			replace: true,
		})
	}

	try {
		const resp = await $ageApi.getAgeGate(store.state.scToken)
		if (resp.status === 200) {
			return redirect({
				path: localePath('/registration/profile/gate'),
				replace: true,
			})
		}
	} catch {}
}
